export const MERCHANT = {
  legalName: 'The ART Foundation',
  tradingName: 'National Knowledge Championship',
  website: 'https://theartfoundation.in',
  supportEmail: 'info@theartfoundation.in',
  supportPhonePrimary: '+91 76399 22228',
  supportPhoneSecondary: '+91 76399 22223',
  address: 'Viveka Nagar, Namakkal, Tamil Nadu, India - 637409',
  supportHours: 'Monday to Friday, 10:00 AM to 7:00 PM IST',
  policyEffectiveDate: '28 September 2026',
} as const;
